import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import Logo from "../Logo";
import { XMarkIcon } from "@heroicons/react/24/solid";
import useSWRImmutable from "swr/immutable";
import FDALogo from "./FDA.svg";
import companyIcon from "./company-icon.svg";
import infobookIcon from "./infobook-icon.svg";

type Props = {
    isOpen: boolean;
    onCancel: () => void;
};

function AboutModal({ isOpen, onCancel }: Props) {
    const { data } = useSWRImmutable<{ version: string }>("/version");
    return (
        <Dialog open={isOpen} onClose={onCancel} className="relative z-50">
            <DialogBackdrop className="fixed inset-0 bg-black/70" />
            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <DialogPanel className="relative flex flex-col bg-blue-light w-[600px] rounded-xl border border-gray-medium font-medium shadow-lg py-5 px-8">
                    <button
                        className="absolute top-0 right-0 m-3 size-9 rounded-full hover:bg-gray-200"
                        onClick={onCancel}
                    >
                        <XMarkIcon className="size-full p-1.5" />
                    </button>
                    <div className="mt-10 flex justify-between items-start">
                        <div className="mt-1">
                            <Logo variant="Medibyt" />
                            <p className="mt-1.5 font-bold text-[#333]">
                                CPETWise by Medibyt LTD
                            </p>
                        </div>
                        <img src={FDALogo} alt="FDA Logo" />
                    </div>
                    <div className="mt-10 flex items-center gap-2">
                        <img src={companyIcon} alt="Company Logo" />
                        <div className="leading-tight">
                            <p>Medibyt LTD</p>
                            <p>Greenwork, Yakum, Israel 6097200</p>
                            <p>contact@medibyt.com</p>
                            <p>+1-424-3932629</p>
                        </div>
                    </div>
                    <div className="mt-5 mb-3 leading-relaxed">
                        <p className="mb-1 text-[#333]">
                            Version {data?.version}
                        </p>
                        <p>
                            UDI: (xx)xxxxxxxxxxxxxx(xx)xxxxxxx(xx)xxxx(xx)xxxx
                        </p>
                        <div className="flex items-center">
                            <img
                                src={infobookIcon}
                                alt="Infobook Icon"
                                className="size-5 mr-2"
                            />
                        </div>
                        <p className="text-[#333]">
                            Privacy/legal information:{" "}
                            {/* eslint-disable-next-line react/jsx-no-target-blank */}
                            <a
                                href="https://www.medibyt.com/product-privacy-policy"
                                className="hover:underline"
                                target="_blank"
                            >
                                CPETWise privacy/legal policy
                            </a>
                        </p>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default AboutModal;
